export const referralSelector = (state) => {
  const { referrals } = state;
  return referrals.referrals;
};
